module.exports = __webpack_public_path__ + "static/media/29FUNOV16.b2cc3cf0.jpg";